import React, { useState, useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import DataList from "../common/dataList/dataList";

import { useDrag } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import TaskRowDragLayer from "../taskDnD/taskRowDragLayer";
import { ItemTypes } from "../taskDnD/dndConstants";
import { STATUSES } from "../../globals/workOrderStatus";
import { getTaskFieldList } from "./taskFieldList";

export const Tasks = ({ tasks, dragging, paneRef, filterTasklist, followUpTypes }) => {
    const intl = useIntl();
    const [scrollVal, setScrollVal] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [dragRow, setDragRow] = useState(null);
    const dragRowRef = useRef(null);

    const fields = getTaskFieldList(intl, followUpTypes);

    const [{ isDragging }, drag, preview] = useDrag({
        item: {
            type: ItemTypes.TASK,
            id: (dragRow || selectedRow)?.workOrderNumber || null,
            duration: (dragRow || selectedRow)?.duration || null,
        },
        canDrag:
            (dragRow || selectedRow) &&
            ((dragRow || selectedRow).statusId === STATUSES.UNASSIGNED || (dragRow || selectedRow).statusId === STATUSES.ASSIGNED),
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    useEffect(() => {
        if (isDragging && (dragRow || selectedRow)) {
            dragRowRef.current = dragRow || selectedRow;
        }
    }, [isDragging, dragRow, selectedRow]);

    useEffect(() => {
        preview(getEmptyImage(), { captureDraggingState: true });
    }, []);

    const handleDragStart = (e) => {
        const targetRow = dragRow || selectedRow;
        if (!targetRow || !(targetRow.statusId === STATUSES.UNASSIGNED || targetRow.statusId === STATUSES.ASSIGNED)) {
            //prevent both native browser dragging and our react react-dnd event dragging if no row is dragged (this shouldnt be possible)
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    };

    const handleTasklistFilter = (filterDetails) => {
        filterTasklist(filterDetails);
    };

    const cmisR3Fields = [
        "locateNumber",
        "requestedDate",
        "expirationDate",
        "permits",
        "followUpType",
        "referenceNumber",
        "latestFollowUpDate",
        "additionalAction",
    ];

    return (
        <div
            className="cmis-task-table"
            ref={dragRow ? drag : selectedRow ? drag : null}
            onDragStart={handleDragStart}
            style={{
                height: paneRef ? paneRef.offsetHeight : 200,
                width: "100%",
                backgroundColor: "white",
            }}>
            <TaskRowDragLayer currentScroll={scrollVal} />
            <DataList
                rows={tasks}
                fields={process.env.REACT_APP_FEATURE_CMISR3 === "true" ? fields : fields.filter((item) => !cmisR3Fields.includes(item.field))}
                dragging={dragging}
                onFilter={handleTasklistFilter}
                onRowMouseDown={setDragRow}
                onSelectionChange={(newSelection) => {
                    const selectedRow = newSelection.rows.length > 0 ? newSelection.rows[0] : null;
                    setSelectedRow(selectedRow);
                }}
            />
        </div>
    );
};

export default Tasks;
